export const EMPLOYMENT_OPTIONS = {
  STATUS: "Patient.Employment.Status",
  EMPLOYER_NAME: "Patient.Employment.EmployerName",
};
